module.exports = __webpack_public_path__ + "img/work_overtime.5c366801.svg";